import React, { useRef, useState } from 'react';
import Image from '../../../../components/Image';
import Popover from '../../../../components/Popover';
import NavbarList from './NavbarList';
import ChevronIcon from 'components/icons/ChevronIcon';
import classnames from 'classnames';
import {useAccount, useUser} from '~/authentication/store';

const CSS = require('./NavbarListItemProfile.less');

const imageOptions = {
  width: 46,
  height: 46,
};

interface NavbarListItemProfileProps {
  transparent: boolean;
}

function NavbarListItemProfile({ transparent }: NavbarListItemProfileProps) {
  const buttonRef = useRef<HTMLButtonElement>();
  const { account } = useAccount();

  const { isHost } = useUser();
  const [menuExpanded, setMenuExpanded] = useState<boolean>(false);

  const onButtonClick = () => {
    setMenuExpanded((expanded: boolean) => !expanded);
  };

  const onClose = () => {
    setMenuExpanded(false);
  };

  const onClickOutside = (event) => {
    if (!buttonRef?.current.contains(event.target)) {
      setMenuExpanded(false);
    }
  }

  return (
    <div>
      <button className={CSS.menuToggle} onClick={onButtonClick} aria-label="Toggle navigation menu" ref={buttonRef}>
        <div className={CSS.HostImageBorder}>
          <Image
            className={CSS.HostImage}
            width={imageOptions.width}
            height={imageOptions.height}
            options={imageOptions}
            src={account?.photo}
          />
        </div>
        {isHost &&
          <ChevronIcon
            className={classnames(CSS.ChevronIcon, {
              [CSS.ChevronIconRotated]: menuExpanded,
              [CSS.ChevronIconWhite]: transparent,
            })}
            width={12}
            height={8}
            direction="bottom"
          />
        }
      </button>
      {menuExpanded &&
        <Popover show className={CSS.popoverContainer} name="navbarMenu" underNavbar onOutSideClick={onClickOutside} onClose={onClose}>
          {menuExpanded && <NavbarList onClick={onClose} isHost={isHost} />}
        </Popover>
      }
    </div>
  );
}

export default NavbarListItemProfile;
